import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ButtonComponent } from './components/button/button.component';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { EmptyStateComponent } from './components/empty-state/empty-state.component';
import { FieldRendererComponent } from './components/field-renderer/field-renderer.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { SectionRendererComponent } from './components/section-renderer/section-renderer.component';
import { SectionTabsComponent } from './components/section-tabs/section-tabs.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { StatusBadgeComponent } from './components/status-badge/status-badge.component';
import { ToastContainerComponent } from './components/toast-container/toast-container.component';

const COMPONENTS = [
  ButtonComponent,
  SpinnerComponent,
  PaginationComponent,
  StatusBadgeComponent,
  ConfirmModalComponent,
  EmptyStateComponent,
  ToastContainerComponent,
  FieldRendererComponent,
  SectionRendererComponent,
  SectionTabsComponent
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  exports: [CommonModule, FormsModule, ReactiveFormsModule, ...COMPONENTS]
})
export class SharedModule {}
